import { AxiosResponse } from 'axios'
import { get } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'
import DataTypeModel from '../../../../models/DataType'

export const getTempoTerminology = (parameters: Record<string, any>, cancelToken): Promise<AxiosResponse<any[]>> =>
    get(apiUrl.terminology.list, DataTypeModel(parameters), cancelToken)
